import React, { useState, useEffect } from "react"
import axios from "axios"
import { navigate } from "gatsby"
import { FormikWizard } from "formik-wizard"
import NewBusinessIcon from "../../../../images/business/new-business.svg"
import { useToasts } from "react-toast-notifications"
import BusinessTitleCard from "../../BusinessCardTitle"
import Summary from "../views/Summary"
import ConfirmModal from "../../ConfirmModal"
import ResponseModal from "../../ResponseModal"
import CheckedIcon from "../../../../images/icons/checked.svg"
import steps from "../steps"

import FailIcon from "../../../../images/icons/failed.svg"
import FormWrapper from "../FormWrapper"

const BusinessReeg = () => {
  const addToast = useToasts()
  const [businessfees, setBusinessFee] = useState("25,000")
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [showSummary, setShowSummary] = useState(false)
  const [accountNo, setAccountNo] = useState("")
  const [openFailModal, setFailModal] = useState(false)
  const [popup, setPopup] = useState(false)
  const [openDoneModal, setOpenDoneModal] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)

  //end the flow
  const goback = () => {
    setOpenDoneModal(false)
     navigate("/business-support/get-started/")
  }
  const backToSummary = () => {
    setFailModal(false)
    setPopup(true)
  }
  const handleSubmit = (values) => {
    setShowSummary(true)
    setData(values)
  }

  const createRecord = async () => {
    setBtnLoading(true)
    let basic_business_info = data.basic_business_info
    let additional_info = data.additional_info
    let proprietor_info = data.proprietor_info
    const combinedData = {
      ...basic_business_info,
      ...additional_info,
      ...proprietor_info,
    }

    try {
      const response = await axios
        .post(
          `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/web/registration/business-name`,
          combinedData,
          {
            headers: {
              Accept: "application/json",
              token: localStorage.getItem("mobile_token"),
            },
          }
        )
        .then((res) => {
          setBtnLoading(false)
          setOpenDoneModal(true)
          localStorage.clear()
        })
    } catch (err) {
      if (err.response.data.message === "Token expired") {
         addToast(`${err.response.data.message}, try again`, {
          appearance: "error",
          placement: "top-center",
          autoDismiss: true,
        })
          navigate("/business-support/get-started/")
           localStorage.clear()
        }
      setBtnLoading(false)
      setFailModal(true)
      // localStorage.clear()
    
    }
  }
  const hidePopup = () => {
    setPopup(false)
  }

  const initPayment = async () => {
    setPopup(true)
  }
  useEffect(() => {
    const storedData = localStorage.getItem("supportFees")

    if (storedData) {
      const parsedData = JSON.parse(storedData)
      setBusinessFee(parsedData)
    } else {
      console.log("No data found in localStorage.")
    }
  }, [])

 useEffect(() => {
  const savedAcct = localStorage.getItem("nuban_id_24b854967");
  if (savedAcct) {
    setAccountNo(savedAcct)
  } else {
    console.log("No account number found in localStorage");
  }
}, []);

  return (
    <div>
      <div className={!showSummary ? "container" : "container d-none"}>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <BusinessTitleCard
              icon={NewBusinessIcon}
              title="Register New Business"
              subtitle="Officially register your business, get CAC and a tax identification number."
            />

            <div className="business-suport-card my-lg-5 waitlist__form ">
              <FormikWizard
                steps={steps}
                onSubmit={handleSubmit}
                render={FormWrapper}
              />
            </div>
          </div>
        </div>
      </div>

      <ConfirmModal
        show={popup}
        closePopup={hidePopup}
        handlePayment={createRecord}
        btnLoader={btnLoading}
        account_no={accountNo}
        amount={businessfees.businessName}
      />
      <ResponseModal
        text1="Your payment for your Sparkle business support service was successful!"
        text2="Your application is on the way and we will get back to you 
        in 24-48 hours."
        title="Payment Successful"
        btnText="Done"
        icon={CheckedIcon}
        show={openDoneModal}
        btnAction={goback}
      />

      <ResponseModal
        text1="Your payment for your Sparkle business support service 
was unsuccessful!"
        text2="Kindly try again"
        title="Payment 
unsuccessful"
        icon={FailIcon}
        show={openFailModal}
        btnAction={backToSummary}
        btnText="Try Again"
      />
      {showSummary && (
        <Summary
          data={data}
          amount={businessfees.businessName}
          payFee={initPayment}
          setShowSummary={setShowSummary}
          loadingStatus={loading}
        />
      )}
    </div>
  )
}

export default BusinessReeg
